module.exports = __webpack_public_path__ + "static/media/west-point-image.8194d9cc.JPG";